import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, dark = false, children }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p
        className={`text-xs font-semibold uppercase tracking-[0.35em] ${
          dark ? "text-gold" : "text-gold"
        }`}
      >
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-heading text-4xl leading-[1.08] sm:text-5xl lg:text-6xl ${
          dark ? "text-ivory" : "text-forest"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {children && (
      <Reveal delay={0.16}>
        <div
          className={`mt-6 text-base leading-relaxed md:text-lg ${
            dark ? "text-ivory/70" : "text-charcoal/70"
          }`}
        >
          {children}
        </div>
      </Reveal>
    )}
  </div>
);
